import Repository from "../../repository";

export default {
    Current: (payload) => Repository.post(`/api/WaterwayReports/Current`, payload),
    DistanceTotal: (payload) => Repository.post(`/api/WaterwayReports/DistanceTotal`, payload),
    DistanceDetail: (payload) => Repository.post(`/api/WaterwayReports/DistanceDetail`, payload),
    LampErrorTotal: (payload) => Repository.post(`/api/WaterwayReports/LampErrorTotal`, payload),
    LampErrorDetail: (payload) => Repository.post(`/api/WaterwayReports/LampErrorDetail`, payload),
}
